import api from './api';

export interface Merchant {
    id: string;
    name: string;
    province: string;
    city: string;
    address: string;
    phone: string;
    email: string;
    pic_name:string;
    pic_phone:string;
    created_at: string;
    updated_at: string;
    merchants: Array<Array<object>>;
    // Add other merchant properties as needed
}

export interface MerchantReg{
    id:string,
    name:string
}

export const merchantsService = {
  // Fetch all merchants
    async fetchMerchants(params: {id?: string, limit?: string, page?: string, search?:string, city_id?:number}): Promise<Merchant[]> {
        const response = await api.get<Merchant[]>('/merchants', { params: params });
        return response.data;
    },
    // fetch merchant by param search
    async searchMerchants(params: {query: string, limit?:string, page?:string}): Promise<Merchant[]> {
        const response = await api.get<Merchant[]>('/merchants', { params: params });
        return response.data;
    },
    //fetch merchant list for register
    async fetchMerchantListReg () : Promise<MerchantReg[]> {
        const response = await api.get<Merchant[]>('/merchants/list/register');
        return response.data;
    }
}